import {Renderer, escapeHtml, type Tokens} from '@time-webkit/marked';

export default class RemoveMarkdown extends Renderer {
    public code({text}: Tokens.Code) {
        return text.replace(/\n/g, ' ');
    }

    public blockquote({tokens}: Tokens.Blockquote) {
        const body = this.parser.parse(tokens);
        return body.replace(/\n/g, ' ');
    }

    public heading({tokens}: Tokens.Heading) {
        return this.parser.parseInline(tokens) + ' ';
    }

    public extendedbr() {
        return '';
    }

    public hr() {
        return '';
    }

    public list({items}: Tokens.List) {
        let content = '';

        for (const item of items) {
            content += this.listitem(item);
        }

        return content;
    }

    public listitem(item: Tokens.ListItem) {
        return this.parser.parse(item.tokens, Boolean(item.loose)) + ' ';
    }

    public paragraph({tokens}: Tokens.Paragraph) {
        return this.parser.parseInline(tokens) + ' ';
    }

    public table() {
        return '';
    }

    public tablerow() {
        return '';
    }

    public tablecell() {
        return '';
    }

    public strong({tokens}: Tokens.Strong) {
        return this.parser.parseInline(tokens);
    }

    public em({tokens}: Tokens.Em) {
        return this.parser.parseInline(tokens);
    }

    public codespan({text}: Tokens.Codespan) {
        const output = escapeHtml(text, true);
        return output.replace(/\n/g, ' ');
    }

    public br() {
        return ' ';
    }

    public del({tokens}: Tokens.Del) {
        return this.parser.parseInline(tokens);
    }

    public link({tokens, text, isUrl}: Tokens.Link & {isUrl?: boolean}) {
        return isUrl ? escapeHtml(text) : this.parser.parseInline(tokens);
    }

    public image({text}: Tokens.Image) {
        return text;
    }

    public text(token: Tokens.Text) {
        let text = super.text(token);
        text = text.replace(/&#39;/g, '&apos;');
        return text.replace('\n', ' ');
    }
}
